import CommentsModule from './comments.module'

export default CommentsModule
